import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  kycDataStudent: {},
  kycDataRemitter: {},
  kycError: false,
  kycLoading: false,
};

export const kycSlice = createSlice({
  name: "kyc",
  initialState,
  reducers: {
    kycSuccessStudent: (state, action) => {
      state.kycDataStudent = action.payload;
    },
    kycSuccessRemitter: (state, action) => {
      state.kycDataRemitter = action.payload;
    },
    kycReset: (state) => {
      state.kycDataStudent = {};
      state.kycDataRemitter = {};
    },  
    kycLoading: (state) => {
      state.kycLoading = true;
    },
    kycError: (state) => {
      state.kycError = true;
    },
  },
});

export const { kycSuccessStudent, kycSuccessRemitter, kycReset, kycLoading, kycError } = kycSlice.actions;

export default kycSlice.reducer;
